exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".menu-user {\n  margin-top: 1.8rem;\n  margin-left: 3px;\n  color: #231f20; }\n  .menu-user .error {\n    font-weight: bold;\n    font-size: 1.2em; }\n  .menu-user .language-container {\n    margin-top: 1.8rem;\n    justify-content: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/MenuUser/MenuUser.scss
// module id = 1434
// module chunks = 0